import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphaNumeric]',
})
export class AlphaNumericDirective {
  @Input('appAlphabetSpaceOnly') appAlphabetSpaceOnly: boolean = false;
  @Input('maxLength') maxLength?: number; // Optional input for max length
  @Input('firstNumberReject') firstNumberReject: boolean = false; // 🔑 new input

  constructor(
    private element: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = this.element.nativeElement as HTMLInputElement;
    let value = input.value?.trimStart() || '';

    // Regex logic
    const regex = this.appAlphabetSpaceOnly
      ? /^[a-zA-Z\s]*$/
      : /^[a-zA-Z0-9\s]*$/;

    // Remove invalid characters
    if (!regex.test(value)) {
      value = value.replace(
        this.appAlphabetSpaceOnly ? /[^a-zA-Z\s]/g : /[^a-zA-Z0-9\s]/g,
        ''
      );
    }

    // 🔑 Disallow number as first character if flag is true
    if (this.firstNumberReject && value.length > 0 && /^\d/.test(value)) {
      value = value.substring(1); // drop the first digit
    }

    // Enforce max length if provided
    if (this.maxLength !== undefined && value.length > this.maxLength) {
      value = value.substring(0, this.maxLength);
    }

    // Update control value
    this.control.control?.setValue(value, { emitEvent: false });
  }
}
